import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import Loader from "../../Loader/Loader";
import {
  getDriverProfile,
  executeDriverAction,
  // sendMessageToDriver,
  // forceDocumentReUpload,
} from "../../service/Mainservice";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StarIcon from "@mui/icons-material/Star";
import WarningIcon from "@mui/icons-material/Warning";
import BlockIcon from "@mui/icons-material/Block";
import SendIcon from "@mui/icons-material/Send";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Modal from "../User/Model";

const DriverDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const driverId = location.state?.id;

  const [loading, setLoading] = useState(true);
  const [driver, setDriver] = useState(null);
  const [activeTab, setActiveTab] = useState("personal");
  const [expandedSections, setExpandedSections] = useState({});

  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    if (driverId) {
      fetchProfile();
    } else {
      navigate("/drivers");
    }
  }, [driverId]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await getDriverProfile(driverId);
      setDriver(res.data.data);
    } catch (error) {
      console.error(error);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      } else {
        alert("Failed to load driver profile");
      }
    } finally {
      setLoading(false);
    }
  };

  // ----- Action Handlers using unified action endpoint -----
  const handleAction = async (action, suspendedUntil = null) => {
    const message = modalData.message || "";
    try {
      await executeDriverAction(driverId, action, suspendedUntil, message);
      const actionMap = {
        suspend:
          "Driver suspended until " +
          (suspendedUntil ? new Date(suspendedUntil).toLocaleDateString() : ""),
        ban: "Driver banned",
        unban: "Driver unbanned",
      };
      alert(actionMap[action] || "Action completed");
      fetchProfile();
    } catch (error) {
      alert("Failed to execute action");
    }
    setModalOpen(false);
  };

  const handleSendMessage = async () => {
    // const message = modalData.message;
    // if (!message) {
    //   alert("Please enter a message");
    //   return;
    // }
    // try {
    //   await sendMessageToDriver(driverId, message);
    //   alert("Message sent successfully");
    // } catch (error) {
    //   alert("Failed to send message");
    // }
    setModalOpen(false);
  };

  const handleForceReUpload = async () => {
    // try {
    //   await forceDocumentReUpload(driverId);
    //   alert("Document re-upload requested successfully");
    //   fetchProfile();
    // } catch (error) {
    //   alert("Failed to request re-upload");
    // }
    setModalOpen(false);
  };

  const openModal = (action, initialData = {}) => {
    setModalAction(action);
    setModalData(initialData);
    setModalOpen(true);
  };

  const toggleExpand = (section, id) => {
    setExpandedSections((prev) => ({
      ...prev,
      [`${section}-${id}`]: !prev[`${section}-${id}`],
    }));
  };

  // ----- Modal Content -----
  const renderModalContent = () => {
    const renderMessageField = () => (
      <div className="modal_field">
        <label>Message (optional)</label>
        <textarea
          placeholder="Add a message..."
          value={modalData.message || ""}
          onChange={(e) =>
            setModalData({ ...modalData, message: e.target.value })
          }
          className="modal_textarea"
          rows="3"
        />
      </div>
    );

    switch (modalAction) {
      case "suspend":
        return (
          <div>
            <h3>Suspend Driver</h3>
            <p>
              Driver will not be able to accept deliveries until the specified
              date.
            </p>
            <div className="modal_field">
              <label>Suspend Until</label>
              <input
                type="date"
                value={modalData.suspendDate || ""}
                onChange={(e) =>
                  setModalData({ ...modalData, suspendDate: e.target.value })
                }
                className="modal_input"
              />
            </div>
            {renderMessageField()}
            <div className="modal_actions">
              <button
                onClick={() => {
                  const date = modalData.suspendDate
                    ? new Date(modalData.suspendDate).toISOString()
                    : null;
                  handleAction("suspend", date);
                }}
                className="btn_danger"
              >
                Suspend
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "ban":
        return (
          <div>
            <h3>Ban Driver</h3>
            <p>This will permanently ban the driver from the platform.</p>
            {renderMessageField()}
            <div className="modal_actions">
              <button
                onClick={() => handleAction("ban")}
                className="btn_danger"
              >
                Ban
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "unban":
        return (
          <div>
            <h3>Unban Driver</h3>
            <p>This will reactivate the driver's account.</p>
            {renderMessageField()}
            <div className="modal_actions">
              <button
                onClick={() => handleAction("unban")}
                className="btn_primary"
              >
                Unban
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "message":
        return (
          <div>
            <h3>Send Message</h3>
            <textarea
              placeholder="Type your message..."
              value={modalData.message || ""}
              onChange={(e) =>
                setModalData({ ...modalData, message: e.target.value })
              }
              className="modal_textarea"
              rows="4"
            />
            <div className="modal_actions">
              <button onClick={handleSendMessage} className="btn_primary">
                Send
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "forceUpload":
        return (
          <div>
            <h3>Force Document Re‑upload</h3>
            <p>
              Driver will be required to re‑upload all documents before going
              online again.
            </p>
            <div className="modal_actions">
              <button onClick={handleForceReUpload} className="btn_primary">
                Confirm
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // ----- Render -----
  if (loading) return <Loader />;
  if (!driver) return <div className="error_msg">Driver not found</div>;

  const { profile, vehicles, orders, withdrawals, reviews, safetyIncidents } =
    driver;

  // Status badge
  let statusBadge = "active";
  let statusText = "Active";
  if (profile.isBlocked) {
    statusBadge = "banned";
    statusText = "Banned";
  } else if (profile.suspendedUntil) {
    statusBadge = "suspended";
    statusText = "Suspended";
  } else {
    const onlineStatus = profile.isAvailable ? "Online" : "Offline";
    statusText = onlineStatus;
    statusBadge = profile.isAvailable ? "online" : "offline";
  }

  // Get vehicle info (first from vehicles array or from profile)
  const vehicle = vehicles?.length ? vehicles[0] : null;

  // Action buttons based on active tab
  const renderActionButtons = () => {
    switch (activeTab) {
      case "personal":
        return (
          <>
            <button
              className="action_btn"
              onClick={() => openModal("forceUpload")}
            >
              <CloudUploadIcon /> Force Re‑upload
            </button>

            {profile.isBlocked ? (
              <button className="action_btn" onClick={() => openModal("unban")}>
                <BlockIcon /> Unban
              </button>
            ) : (
              <button className="action_btn" onClick={() => openModal("ban")}>
                <BlockIcon style={{ color: "red" }} /> Ban
              </button>
            )}
            <button className="action_btn" onClick={() => openModal("suspend")}>
              <BlockIcon /> Suspend
            </button>
            {/* <button className="action_btn" onClick={() => openModal("message")}>
              <SendIcon /> Send Message
            </button> */}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="userdetails_container">
        {/* Header */}
        <div className="details_header">
          <button className="back_btn" onClick={() => navigate("/drivers")}>
            ← Back to Drivers
          </button>
          <h2>Driver Details</h2>
        </div>

        {/* Profile Summary */}
        <div className="profile_summary">
          <div className="avatar">
            {profile.image ? (
              <img src={profile.image} alt={profile.fullName} />
            ) : (
              <PersonOutlineIcon style={{ fontSize: 60 }} />
            )}
          </div>
          <div className="summary_info">
            <h3>{profile.fullName}</h3>
            <p>
              <EmailIcon fontSize="small" /> {profile.email}
            </p>
            <p>
              <PhoneIcon fontSize="small" /> {profile.mobilenumber}
            </p>
            <p>
              Status:{" "}
              <span className={`badge ${statusBadge}`}>{statusText}</span>
              {profile.zone && <span className="zone_tag">{profile.zone}</span>}
            </p>
            <p>Joined: {new Date(profile.createdAt).toLocaleDateString()}</p>
          </div>
          <div className="summary_stats">
            <div>
              <strong>{orders?.length || 0}</strong>
              <span>Total Deliveries</span>
            </div>
            <div>
              <strong> {profile.totalRating || 0}</strong>
              <span>Rating</span>
            </div>
            <div>
              <strong>
                {profile.totalOnlineSecondsToday
                  ? Math.round(profile.totalOnlineSecondsToday / 60)
                  : 0}
                m
              </strong>
              <span>Online Today</span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "personal" ? "tab_active" : ""}
            onClick={() => setActiveTab("personal")}
          >
            <PersonOutlineIcon /> Personal
          </button>
          <button
            className={activeTab === "vehicle" ? "tab_active" : ""}
            onClick={() => setActiveTab("vehicle")}
          >
            <DirectionsCarIcon /> Vehicle
          </button>
          <button
            className={activeTab === "documents" ? "tab_active" : ""}
            onClick={() => setActiveTab("documents")}
          >
            <DescriptionIcon /> Documents
          </button>
          <button
            className={activeTab === "deliveries" ? "tab_active" : ""}
            onClick={() => setActiveTab("deliveries")}
          >
            <ReceiptIcon /> Deliveries ({orders?.length || 0})
          </button>
          <button
            className={activeTab === "earnings" ? "tab_active" : ""}
            onClick={() => setActiveTab("earnings")}
          >
            <AttachMoneyIcon /> Earnings
          </button>
          <button
            className={activeTab === "ratings" ? "tab_active" : ""}
            onClick={() => setActiveTab("ratings")}
          >
            <StarIcon /> Ratings ({reviews?.length || 0})
          </button>
          <button
            className={activeTab === "safety" ? "tab_active" : ""}
            onClick={() => setActiveTab("safety")}
          >
            <WarningIcon /> Safety ({safetyIncidents?.length || 0})
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab_content">
          {activeTab === "personal" && (
            <div className="personal_info">
              <div className="info_section">
                <h4>Personal Details</h4>
                <div className="detail_row">
                  <span>Full Name</span> <strong>{profile.fullName}</strong>
                </div>
                <div className="detail_row">
                  <span>Email</span> <strong>{profile.email}</strong>
                </div>
                <div className="detail_row">
                  <span>Mobile</span> <strong>{profile.mobilenumber}</strong>
                </div>
                <div className="detail_row">
                  <span>Zone</span> <strong>{profile.zone || "N/A"}</strong>
                </div>
                <div className="detail_row">
                  <span>Emergency Contact</span>{" "}
                  <strong>
                    {profile.emergencyContactName || "N/A"} (
                    {profile.emergencyContactPhone || "N/A"})
                  </strong>
                </div>
                <div className="detail_row">
                  <span>Verified</span>{" "}
                  <strong>{profile.isVerify ? "✅ Yes" : "❌ No"}</strong>
                </div>
                <div className="detail_row">
                  <span>Total Earnings</span>{" "}
                  <strong>${profile.totalEarnings || 0}</strong>
                </div>
              </div>
            </div>
          )}

          {activeTab === "vehicle" && (
            <div className="vehicle_info">
              {vehicle ? (
                <div className="info_section">
                  <h4>Vehicle Details</h4>
                  <div className="detail_row">
                    <span>Type</span> <strong>{vehicle.type || "N/A"}</strong>
                  </div>
                  <div className="detail_row">
                    <span>Make</span> <strong>{vehicle.make || "N/A"}</strong>
                  </div>
                  <div className="detail_row">
                    <span>Model</span> <strong>{vehicle.model || "N/A"}</strong>
                  </div>
                  <div className="detail_row">
                    <span>Year</span> <strong>{vehicle.year || "N/A"}</strong>
                  </div>
                  <div className="detail_row">
                    <span>Color</span> <strong>{vehicle.color || "N/A"}</strong>
                  </div>
                  <div className="detail_row">
                    <span>License Plate</span>{" "}
                    <strong>{vehicle.licensePlate || "N/A"}</strong>
                  </div>
                </div>
              ) : (
                <p className="no_data">No vehicle information available.</p>
              )}
            </div>
          )}

          {activeTab === "documents" && (
            <div className="documents">
              {profile.documents?.images?.length ? (
                profile.documents.images.map((doc, i) => (
                  <div key={i} className="document_item">
                    <div className="doc_header">
                      <strong>{doc.name}</strong>
                      <span className="doc_status">
                        {doc.expirationDate
                          ? `Expires: ${new Date(doc.expirationDate).toLocaleDateString()}`
                          : ""}
                      </span>
                    </div>
                    <div className="doc_images">
                      {doc.data.map((url, idx) => (
                        <img
                          key={idx}
                          src={url}
                          alt={doc.name}
                          className="doc_thumb"
                        />
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <p className="no_data">No documents uploaded.</p>
              )}
            </div>
          )}

          {activeTab === "deliveries" && (
            <div className="deliveries">
              {orders?.length ? (
                orders.map((order) => (
                  <div key={order.id} className="delivery_card">
                    <div
                      className="delivery_header"
                      onClick={() => toggleExpand("delivery", order.id)}
                    >
                      <div className="delivery_summary">
                        <span className="delivery_id">
                          #{order.orderNumber || "N/A"}
                        </span>
                        <span className="delivery_date">
                          {new Date(order.createdAt).toLocaleDateString()}
                        </span>
                        <span className="delivery_total">
                          ${order.totalPrice}
                        </span>
                        <span
                          className={`badge ${order.orderStatus.toLowerCase()}`}
                        >
                          {order.orderStatus}
                        </span>
                      </div>
                      <button className="expand_btn">
                        {expandedSections[`delivery-${order.id}`] ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </button>
                    </div>
                    {expandedSections[`delivery-${order.id}`] && (
                      <div className="delivery_details">
                        <p>
                          <strong>Vendor:</strong>{" "}
                          {order.vendor?.shopName || "N/A"}
                        </p>
                        <p>
                          <strong>Customer:</strong>{" "}
                          {order.customer?.name || "N/A"}
                        </p>
                        <p>
                          <strong>Address:</strong>{" "}
                          {order.shippingAddress || "N/A"}
                        </p>
                        <p>
                          <strong>Payment:</strong> {order.paymentMethod}
                        </p>
                        <p>
                          <strong>Tip:</strong> ${order.tipAmont || 0}
                        </p>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p className="no_data">No delivery history.</p>
              )}
            </div>
          )}

          {activeTab === "earnings" && (
            <div className="earnings">
              {withdrawals?.length ? (
                withdrawals.map((withdrawal) => (
                  <div key={withdrawal.id} className="earning_row">
                    <span>
                      {new Date(withdrawal.date).toLocaleDateString()}
                    </span>
                    <span>${withdrawal.amount}</span>
                    <span
                      className={`badge ${withdrawal.status?.toLowerCase()}`}
                    >
                      {withdrawal.status || "Completed"}
                    </span>
                  </div>
                ))
              ) : (
                <p className="no_data">No earnings data available.</p>
              )}
            </div>
          )}

          {activeTab === "ratings" && (
            <div className="ratings">
              {reviews?.length ? (
                reviews.map((review) => (
                  <div key={review.id} className="rating_item">
                    <div className="rating_header">
                      <strong>{review.customerName || "Anonymous"}</strong>
                      <span> {review.rating}</span>
                    </div>
                    <p>{review.comment || review.feedback}</p>
                    <small>
                      {new Date(review.createdAt).toLocaleDateString()}
                    </small>
                  </div>
                ))
              ) : (
                <p className="no_data">No ratings yet.</p>
              )}
            </div>
          )}

          {activeTab === "safety" && (
            <div className="safety">
              {safetyIncidents?.length ? (
                safetyIncidents.map((incident) => (
                  <div key={incident.id} className="incident_item">
                    <div className="incident_header">
                      <strong>{incident.type}</strong>
                      <span className={`badge ${incident.severity}`}>
                        {incident.severity}
                      </span>
                    </div>
                    <p>{incident.description}</p>
                    <small>
                      {new Date(incident.date).toLocaleDateString()}
                    </small>
                  </div>
                ))
              ) : (
                <p className="no_data">No safety incidents reported.</p>
              )}
            </div>
          )}
        </div>

        {/* Actions Bar */}
        <div className="actions_bar">{renderActionButtons()}</div>
      </div>

      {/* Modal */}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        {renderModalContent()}
      </Modal>
    </>
  );
};

export default DriverDetails;
